<div class="background-image">
  <div class="flex flow-row align-items-center">
    <p-image class="flex pr-7" src="../../../../assets/light-logo.svg" alt="Image" width="295" height="117"/>
    <h1 class="home-title">Bienvenido a <br>
      Módulo FEC</h1>
  </div>
</div>

